import { render, staticRenderFns } from "./AnggotaPartial.vue?vue&type=template&id=3c3a0494&scoped=true&"
import script from "./AnggotaPartial.vue?vue&type=script&lang=js&"
export * from "./AnggotaPartial.vue?vue&type=script&lang=js&"
import style0 from "./AnggotaPartial.vue?vue&type=style&index=0&id=3c3a0494&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3a0494",
  null
  
)

export default component.exports